import React from "react";
import clsx from "clsx";
import { Card } from "@curves/ui-base";
import CartTable from "@icoach/healthyCyclePurchase/components/CartTable";

const ProductSectionByRead = props => {
	const { titleClassName = "bg-light-active", sourceData = {} } = props;
	const { items } = sourceData;

	return (
		<React.Fragment>
			<Card.CardHeader title="訂購商品" className={clsx("px-4", titleClassName)} />
			<Card.CardContent className="px-4 pt-2 pb-4">
				<CartTable className="mb-4" sourceData={items} readOnly />
			</Card.CardContent>
		</React.Fragment>
	);
};

export default ProductSectionByRead;
